import { React, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";

//components
import GenderHeader from "../../components/Header";
import CustomButton from "../../components/Button";

//database
import { getQuestionById } from "../../database/db";

export default function ReasonScreen() {
  const { id } = useParams();
  const [dado, setDados] = useState([]);
  const [isLoading, setLoading] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    //console.error("[response.js > useEffect()] passei aqui...");

    async function fetchData() {
      const result = await getQuestionById(id);
      setDados(result);
      setLoading(0);
    }
    fetchData();
  }, [id]);

  return (
    <Grid
      container
      spacing={2}
      sx={{
        minHeight: "100vh",
      }}
    >
      <Grid item xs></Grid>
      <Grid item xs={10}>
        <Grid
          container
          spacing={2}
          sx={{
            marginBottom: {
              xs: "25%",
              sm: "5%",
              md: "5%",
              lg: "0",
              xl: "0",
            },
          }}
        >
          <Grid item xs={12}>
            <GenderHeader></GenderHeader>
          </Grid>
          <Grid item xs={12}>
            <Typography
              color={"#000000"}
              letterSpacing={0}
              fontSize={"1em"}
              fontWeight={700}
              fontFamily={"Inter, Helvetica, sans-serif"}
              lineHeight={"0.9375em"}
              padding={"2% 10% 0"}
            >
              fundamentação
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              color={"#757575"}
              letterSpacing={0}
              fontSize={"1.25em"}
              fontWeight={700}
              fontFamily={"Inter, Helvetica, sans-serif"}
              lineHeight={"1.31875em"}
              padding={"0 10%"}
            >
              {isLoading === 1 ? "A carregar resposta..." : dado.reason}
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign={"center"} marginTop={"2vh"}>
            <CustomButton
              title={"verdadeiro"}
              type={"CheckCircleIcon"}
              width={"13.25em"}
              height={"3.6875em"}
              backcolor={dado.correct === 1 ? "1" : ""}
              animation={dado.correct === 1 ? "bounce 0.9s 2" : ""}
              disabled={"true"}
            ></CustomButton>
          </Grid>
          <Grid item xs={12} textAlign={"center"}>
            <CustomButton
              title={"falso"}
              type={"ClearIcon"}
              width={"8.625em"}
              height={"3.6875em"}
              backcolor={dado.correct === 0 ? "0" : ""}
              animation={dado.correct === 0 ? "shake 0.3s 2" : ""}
              disabled={"true"}
            ></CustomButton>
          </Grid>
          <Grid item xs={12} textAlign={"center"}>
            <ArrowForwardOutlinedIcon
              sx={{
                width: {
                  xs: "10vw",
                  sm: "10vw",
                  md: "7vw",
                  lg: "4vw",
                  xl: "4vw",
                },
                height: "auto",
                animation: "shake 3s infinite",
              }}
              onClick={() => navigate("/question")}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
}
